export const CAROUSEL_CONTENT = {
  NAKED_NEWS: {
    heading1: 'Welcome to',
    heading2: 'Naked News',
    content: 'Hottest News Show on the Planet',
    color: '#ffffff',
    uppercase: true,
    ctaLink: '/account/purchase?tour_video=general',
  },
  NAKED_NEWS_LIVE: {
    heading1: 'Naked News',
    heading2: 'Live',
    content:
      'Interact with the world\'s sexiest adult content creators',
    color: '#ffffff',
    uppercase: true,
    ctaLink: '/account/purchase?tour_video=naked news live',
  },
  AUDITIONS: {
    heading1: 'Naked News',
    heading2: 'Auditions',
    content: 'Hundreds of amateur auditions',
    color: '#ffffff',
    uppercase: true,
    ctaLink: '/account/purchase?tour_video=audition',
  },
};

export const mainCarouselContent = {
  'callToAction': 'It\'s time for you to join our groundbreaking program, Naked News! Forget about conventional shows and immerse yourself in a world full of excitement and Naked News models! Our naked anchors will leave you breathless and  guarantee you an experience that you won\'t soon forget. Become a member of Naked News today and start enjoying the news like never before. Our variety of mainstream and adult themed features will have you hooked and coming back for a daily dose of nude news. So what are you waiting for, come and join the party right now at NakedNews.com!',
  'main': 'The sexiest naked reporters around the world cover news, sports, pop culture and much more. And while they strip down the facts, they strip down themselves. Enjoy 6 new naked shows a week, plus exclusive access to our archives containing thousands of segments including our popular naked news auditions. Sign up now to discover why we are the program with nothing to hide!',
};
